import "./ButtonGroupBlock.scss";
import {
  BlockTop,
  ButtonLargeSpecialBlock,
  GridPresetOneHalf,
  GridPresetOneThird,
  GridPresetWideContent,
  GridRow,
  OptimizelyEditProperty,
} from "/App.Components";
import { ButtonGroupBlockProps } from "/Models/Generated/ButtonGroupBlockProps";
import { RowSpacing } from "../../Layout/GridRow/GridRow";

const ButtonGroupBlock = ({
  buttonsPerRow,
  blockTop,
  items,
  itemsPropertyName,
}: ButtonGroupBlockProps) => {
  const ColumnComponent =
    buttonsPerRow === 1
      ? GridPresetWideContent
      : buttonsPerRow === 2
        ? GridPresetOneHalf
        : GridPresetOneThird;
  return (
    <div className={"button-group-block-norad"}>
      <GridRow>
        {blockTop && (
          <GridPresetWideContent>
            <BlockTop {...blockTop} />
          </GridPresetWideContent>
        )}
      </GridRow>
      <OptimizelyEditProperty propertyName={itemsPropertyName} clientRender>
        <GridRow rowSpacing={RowSpacing.buttonGroupBlock}>
          {(items?.length ?? 0) > 0 &&
            items?.map((item, idx) => (
              <ColumnComponent key={idx}>
                <ButtonLargeSpecialBlock {...item} />
              </ColumnComponent>
            ))}
        </GridRow>
      </OptimizelyEditProperty>
    </div>
  );
};

export default ButtonGroupBlock;
